import { Directive, Output, EventEmitter, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[ngxAppDragDrop]',
    standalone: false
})
export class DragDropDirective {
  @Input() disabled: boolean = false;
  @Output() onFileDropped = new EventEmitter<any>();

  @HostBinding('style.background-color') public background = '#fff';
  @HostBinding('style.opacity') public opacity = '1';
  @HostBinding('style.border-radius') public borderRadius = '6px';

  // Dragover listener
  @HostListener('dragover', ['$event']) onDragOver(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#edf1f7';
    this.opacity = '0.8';
  }

  // Dragleave listener
  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#fff';
    this.opacity = '1';
  }

  // Drop listener
  @HostListener('drop', ['$event']) public ondrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#fff';
    this.opacity = '1';
    const files = evt.dataTransfer.files;
    if (files.length > 0 && !this.disabled) {
      this.onFileDropped.emit(files);
    }
  }
}
